import script from "./DomainModelRoles.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelRoles.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelRoles.vue?vue&type=style&index=0&id=500bf3e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-500bf3e2"]])

export default __exports__